<div class="modal-header border-bottom-0">
  <h5 class="modal-title">{{'common.planItem.benefitsInclude' | translate}}</h5>
  <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body pb-5">
  <ul class="m-0 pl-5">
    <li *ngFor="let benefit of benefits" class="pt-2">{{benefit}}</li>
  </ul>
</div>
